import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css



import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control

import Blob from './Excel/Blob'
import Export2Excel from './Excel/Export2Excel.js'

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

// 注册全局弹窗组件
import defalutPopup from '@/components/public/defalut-popup/index'
Vue.use(defalutPopup);

Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'
//  全局图片请求路径
Vue.prototype.$imageBaseUrl = process.env.Image_BASE_API;
// console.log('process.env.Image_BASE_API',process.env.Image_BASE_API);
Vue.use(VueClipboard)


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js